import type { Locale } from '../../../i18n-config';
import { i18n } from '../../../i18n-config';
import { detectBrowserLocale } from '../utils/locale.utils';
import { createHydratedStorage } from './hydrated.store';

export type ThemeSetting = 'light' | 'dark' | 'system';

interface PreferencesState {
  themeSetting: ThemeSetting;
  setThemeSetting: (theme: ThemeSetting) => void;
  locale: Locale;
  setLocale: (locale: Locale) => void;
}

/**
 * Gets the initial locale, falling back to browser detection if not set.
 */
function getInitialLocale(): Locale {
  const browserLocale = detectBrowserLocale();
  if (i18n.locales.includes(browserLocale)) {
    return browserLocale;
  }
  return i18n.defaultLocale;
}

export const usePreferencesStore = createHydratedStorage<PreferencesState>(
  (set) => ({
    themeSetting: 'system',
    setThemeSetting: (theme) => set({ themeSetting: theme }),
    locale: getInitialLocale(),
    setLocale: (locale) => set({ locale }),
  }),
  {
    name: 'preferences-store',
  },
);
